import { render, staticRenderFns } from "./outlinetable.vue?vue&type=template&id=638f47c2&scoped=true&"
import script from "./outlinetable.vue?vue&type=script&lang=js&"
export * from "./outlinetable.vue?vue&type=script&lang=js&"
import style0 from "./outlinetable.vue?vue&type=style&index=0&id=638f47c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638f47c2",
  null
  
)

export default component.exports